import { useEffect, useState } from "react";
import ProfileTabsNav from "../../components/ProfileTabsNav";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import {
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  HtmlTooltip,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import { v4 as uuid } from "uuid";
import ConfirmPopup from "../../components/ConfirmPopup";
import PharmacyDataList from "../PharmacyDataList";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import {
  PatientProfilePharmacyInfo,
  RemovePatientProfilePharmacyInfoById,
} from "../../Apis/AuthApiServices";
import NoRecords from "../../components/NoRecords";
import YSSnackBar from "../../uikit/YSSnackBar";
import ErrorOverlay from "../../components/ErrorOverlay";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ErxWarning from "../../images/icons/ErxWarning.svg";
import ErxSuccess from "../../images/icons/ErxSuccess.svg";
import ErxError from "../../images/icons/ErxError.svg";

export default function PharmacyInformation() {
  const navigate = useNavigate();
  const [PharmacyInfoData, setPharmacyInfoData] = useState([]);
  const [pagination, setPagination] = useState<any>();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectionData, setSelectionData] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [pharmacyInfoState, setPharmacyInfoState] = useState(false);
  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };
  const [showPopupP, setShowPopupP] = useState(false);
  const handleShowPopupClickP = () => {
    setShowPopupP(true);
  };
  const handleHidePopupClickP = () => {
    setShowPopupP(false);
  };
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);

  const columnsPharmacyInformation: GridColDef[] = [
    {
      field: "pharmacyName",
      headerName: "Pharmacy Name / Address",
      width: 200,
      cellClassName: "w55",
      headerClassName: "w55",
      renderCell: ({ row }) => (
        <Typography component={"div"}>
          <Grid
            container
            display={"flex"}
            justifyContent={"left"}
            alignItems={"center"}
            gap={1}
          >
            <Grid item>
              <Typography variant="body2">{row?.pharmacyName} </Typography>
            </Grid>
            {row?.ssEnabledFlag === false ? (
              <Grid item>
                <HtmlTooltip
                  placement="right"
                  arrow
                  title={
                    "Electronic transmission of prescriptions is disabled for this pharmacy."
                  }
                >
                  <img src={ErxError} alt="erx-error" height={24} />
                </HtmlTooltip>
              </Grid>
            ) : row?.epcsEnabled ? (
              <Grid item>
                <HtmlTooltip
                  placement="right"
                  arrow
                  title={
                    "This pharmacy supports electronic prescription transmission."
                  }
                >
                  <img src={ErxSuccess} alt="erx-success" height={24} />
                </HtmlTooltip>
              </Grid>
            ) : (
              <Grid item>
                <HtmlTooltip
                  placement="right"
                  arrow
                  title={
                    "Electronic transmission of prescriptions containing Controlled drugs is not supported by this pharmacy."
                  }
                >
                  <img src={ErxWarning} alt="erx-warning" height={24} />
                </HtmlTooltip>
              </Grid>
            )}
          </Grid>
          <Typography color="black" variant="caption">
            <LocationOnIcon style={{ height: 12, width: 12 }} />
            {row?.address}
          </Typography>
        </Typography>
      ),
    },
    {
      field: "store",
      headerName: "Store",
      width: 80,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    // {
    //   field: "address",
    //   headerName: "Address",
    //   width: 200,
    //   cellClassName: "w25",
    //   headerClassName: "w25",
    //   renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    // },
    {
      field: "landmark",
      headerName: "Land Mark",
      width: 120,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    {
      field: "telephone",
      headerName: "Telephone",
      width: 100,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "faxno",
      headerName: "Fax No",
      width: 100,
      cellClassName: "w13",
      headerClassName: "w13",
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <Tooltip title="Delete">
            <IconButton
              type="button"
              onClick={() => {
                handleShowDeletePopupClick();
                setSelectionData(row.pharmacyCode);
              }}
            >
              <img src={TrashIcon} alt="Delete" loading="lazy" />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      const patientId: any = sessionStorage.getItem("patientId");
      params.append("patientId", patientId);
      params.append("selectedPharmacy", selectionData);
      const result = await RemovePatientProfilePharmacyInfoById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getPharmacyInformation(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getPharmacyInformation = async (nextPage: any) => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      const patientId: any = sessionStorage.getItem("patientId");
      params.append("patientId", patientId);
      params.append("pageNumber", nextPage);
      const result = await PatientProfilePharmacyInfo(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setPharmacyInfoData(result?.data?.response[0]?.items);
        setPagination(result?.data?.response[0]?.pagination);
        setLoading(false);
      } else {
        setPharmacyInfoData([]);
        setPagination(0);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      setError(true);
    }
  };

  const [rowCountState, setRowCountState] = useState(
    pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      pagination?.totalItems !== undefined
        ? pagination?.totalItems
        : prevRowCountState
    );
  }, [pagination?.totalItems, setRowCountState]);

  useEffect(() => {
    getPharmacyInformation(page);
  }, [page]);

  return (
    <>
      <ProfileTabsNav />
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Pharmacy Information{" "}
          <HelpGuideTooltip
            content={
              <>
                <Typography component="div" variant="body1">
                  This would display the favorite Pharmacy that the prescriber
                  has chosen for the patient's record.
                </Typography>
              </>
            }
          />
        </Typography>

        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={PharmacyInfoData ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsPharmacyInformation}
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowHeight={() => "auto"}
                paginationMode="server"
                checkboxSelection
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                getRowId={(row) => row.pharmacyCode ?? uuid()}
                loading={loading}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={() => {
                  navigate("/newrxpad");
                }}
                className=""
                children={"Back to NewRx"}
                size={"large"}
                type="button"
                color="primary"
                variant="outlined"
              />{" "}
              <YSButton
                onClick={() => {
                  handleShowPopupClickP();
                  setPharmacyInfoState(true);
                }}
                className=""
                children={"Add New Pharmacy"}
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
        </Grid>
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <DialogPopup
        windowsize={"md"}
        title={"Search Pharmacies"}
        show={showPopupP}
        handleShowPopupClick={handleShowPopupClickP}
        handleHidePopupClick={handleHidePopupClickP}
      >
        <PharmacyDataList
          handleHidePopupClick={handleHidePopupClickP}
          pharmacyInfoState={pharmacyInfoState}
          getPharmacyInformation={() => getPharmacyInformation(page)}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
